/*Sidebar*/

import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_beneficios from './../UI/icons/Sidebar/Puntos-interes.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Puntos-interes2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto2.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_lobby from './../UI/icons/Amenities/Porteria.svg'
import i_lobby2 from './../UI/icons/Amenities/Porteria White.svg'
import i_pool from './../UI/icons/Amenities/Piscina.svg'
import i_pool2 from './../UI/icons/Amenities/Piscina_White.svg'
import i_aqua from './../UI/icons/Amenities/Acuaparque.svg'
import i_aqua2 from './../UI/icons/Amenities/Acuaparque_white.svg'
import i_campestre from './../UI/icons/Amenities/AreaCampestre.svg'
import i_campestre2 from './../UI/icons/Amenities/AreaCampestre_White.svg'
import i_jardin from './../UI/icons/Amenities/Jardines.svg'
import i_jardin2 from './../UI/icons/Amenities/Jardines_White.svg'
import i_cancha from './../UI/icons/Amenities/CanchaMultiple.svg'
import i_cancha2 from './../UI/icons/Amenities/CanchaMultiple_White.svg'
import i_bbq from './../UI/icons/Amenities/BBQ.svg'
import i_bbq2 from './../UI/icons/Amenities/BBQ_white.svg'
import i_salonSocial from './../UI/icons/Amenities/Salon Social.svg'
import i_salonSocial2 from './../UI/icons/Amenities/Salon Social_White.svg'
import i_wifi from './../UI/icons/Amenities/Gym.svg'
import i_wifi2 from './../UI/icons/Amenities/Gym_white.svg'
import i_saloncomunal from './../UI/icons/Amenities/saloncomunal.svg'
import i_commercialarea from './../UI/icons/Amenities/AreaCampestre.svg'
import i_crossfit from './../UI/icons/Amenities/crossfit.svg'
import i_yoga from './../UI/icons/Amenities/Yoga2.svg'
import i_books from './../UI/icons/Amenities/books.svg'
import i_estadia from './../UI/icons/Amenities/estadia.svg'
import i_massage from './../UI/icons/Amenities/BBQ.svg'
import i_ping from './../UI/icons/Amenities/Salon Social.svg'
import i_playground from './../UI/icons/Amenities/Juegos infantiles.svg'
import i_playground2 from './../UI/icons/Amenities/Juegos infantiles_White.svg'

import i_commercialarea2 from './../UI/icons/Amenities/AreaCampestre.svg'

import i_sun from './../UI/icons/Amenities/Piscina_White.svg'
import i_jacuzzi from './../UI/icons/Amenities/Jardines.svg'

/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte2.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques2.svg'

import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Lobby': i_lobby,
    'Lobby2': i_lobby2,
    'Zona Piscina': i_pool,
    'Zona Piscina2': i_pool2,
    'Acuaparque': i_aqua,
    'Acuaparque2': i_aqua2,
    'Área Campestre': i_campestre,
    'Área Campestre2': i_campestre2,
    'Zona Jardines': i_jardin,
    'Zona Jardines2': i_jardin2,
    'Cancha Múltiple': i_cancha,
    'Cancha Múltiple2': i_cancha2,
    'BBQ': i_bbq,
    'BBQ2': i_bbq2,
    'Salón Social': i_salonSocial,
    'Salón Social2': i_salonSocial2,
    'Zona Comercial': i_commercialarea,
    'Zona Comercial2': i_commercialarea2,
    'Zona de Asoleación': i_sun,
    'Zona de Asoleación2': i_sun,
    'Asoleación - Jacuzzi Seco': i_jacuzzi,
    'Asoleación - Jacuzzi Seco2': i_jacuzzi,
    'Gimnasio': i_wifi,
    'Gimnasio2': i_wifi2,

    'Zona de Masajes': i_massage,
    'Zona de Masajes2': i_massage,
    'Zona de Ping Pong': i_ping,
    'Zona de Ping Pong2': i_ping,
    'Parque Infantil': i_playground,
    'Parque Infantil2': i_playground2,


    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Transporte": i_transporte,
    "Transporte2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Colegios": i_colegios,
    "Colegios2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
}